import React from 'react'
import { BarChart3, CalendarClock, CheckCircle2, IndianRupee, PackageCheck, PieChart, Send, ShoppingBag, TrendingDown, TrendingUp, Wallet } from 'lucide-react'
import LanguageTranslator from '../../../../locals/LanguageTranslator'

// The design uses a small set of white glyphs sitting on a 24px coloured tile. The cards only
// carry the icon name so the data files stay free of jsx.
const CARD_ICONS = {
    shoppingBag: ShoppingBag,
    barChart: BarChart3,
    pieChart: PieChart,
    rupee: IndianRupee,
    grc: PackageCheck,
    outstanding: Wallet,
    dueDate: CalendarClock,
    send: Send,
    checkCircle: CheckCircle2,
}

export const CardIcon = ({ icon, background }) => {
    const Icon = CARD_ICONS?.[icon] || PackageCheck;
    return (
        <div className='shrink-0 size-[24px] rounded-[5px] flex items-center justify-center' style={{ backgroundColor: background }}>
            <Icon size={14} color='#FFFFFF' strokeWidth={1.6} />
        </div>
    )
}

// Qty on the left, amount right aligned. Shared by every tile on the dashboard.
export const QtyAmountRow = ({ qty = 0, amount = "₹ 0" }) => {
    return (
        <div className='w-full flex items-start justify-between gap-2'>
            <div className='flex flex-col items-start whitespace-nowrap'>
                <LanguageTranslator tag='p' className='mb-0 text-[11px] font-normal text-[#4A5D7A]'>Qty</LanguageTranslator>
                <p className='mb-0 text-[14px] font-semibold text-[#111D31]'>{qty}</p>
            </div>
            <div className='flex flex-col items-end text-right whitespace-nowrap'>
                <LanguageTranslator tag='p' className='mb-0 text-[11px] font-normal text-[#4A5D7A]'>Amount</LanguageTranslator>
                <p className='mb-0 text-[14px] font-semibold text-[#111D31]'>{amount}</p>
            </div>
        </div>
    )
}

// Small pill under the sales summary cards : green for a gain, red for a drop.
const TrendPill = ({ change, trend }) => {
    const isUp = trend == "up";
    const Icon = isUp ? TrendingUp : TrendingDown;
    return (
        <div className={`h-[20px] flex items-center justify-center gap-[6px] px-[10px] rounded-[4px] ${isUp ? 'bg-[#F0FDF4]' : 'bg-[rgba(251,44,54,0.1)]'}`}>
            <Icon size={12} color={isUp ? "#16A34A" : "#FB2C36"} strokeWidth={1.6} />
            <p className={`mb-0 text-[12px] font-medium whitespace-nowrap ${isUp ? 'text-[#16A34A]' : 'text-[#FB2C36]'}`}>{change}</p>
        </div>
    )
}

// The plain white metric tile used by the sales summary row, the GRC row and the transaction
// details row. `change` is optional, only the summary row shows the trend pill.
const BusinessDashboardCard = ({ title, icon, iconBg, qty, amount, change, trend, className = "" }) => {
    return (
        <div className={`bg-white border border-borderSlateGrey rounded-[10px] p-[10px] flex flex-col justify-between gap-[10px] ${className}`}>
            <div className='w-full flex items-center justify-between gap-2'>
                <LanguageTranslator tag='p' className='mb-0 capitalize text-[11px] font-normal leading-[1.4] text-[#111D31]'>{title}</LanguageTranslator>
                <CardIcon icon={icon} background={iconBg} />
            </div>
            <QtyAmountRow qty={qty} amount={amount} />
            {change ? <TrendPill change={change} trend={trend} /> : null}
        </div>
    )
}

export default BusinessDashboardCard
